import { paginatedQuery } from 'lib-shared-api-utils';
import type {
  ApiResponse,
  CreateQueueAgentsApiArg,
  CreateQueueApiArg,
  CreateQueueApiResponse,
  CreateQueueTeamsApiArg,
  DeleteQueueAgentsApiArg,
  DeleteQueueTeamApiArg,
  ReadQueueAgentsApiArg,
  ReadQueueAgentsApiResponse,
  ReadQueueApiArg,
  ReadQueueApiResponse,
  ReadQueuesApiArg,
  ReadQueuesApiResponse,
  ReadQueueTeamsApiArg,
  ReadQueueTeamsApiResponse,
  UpdateQueueAgentsApiArg,
  UpdateQueueApiArg,
  UpdateQueueApiResponse,
  UpdateQueueTeamsApiArg,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

export const queuesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createQueue: builder.mutation<CreateQueueApiResponse, CreateQueueApiArg>({
      query: ({ queue: data }) => ({
        version: 2,
        path: 'queues',
        method: 'POST',
        data,
      }),
    }),
    readQueue: builder.query<ReadQueueApiResponse, ReadQueueApiArg>({
      query: ({ id }) => ({
        version: 2,
        path: `queues/${id}`,
      }),
    }),
    updateQueue: builder.mutation<UpdateQueueApiResponse, UpdateQueueApiArg>({
      query: ({ id, queue }) => ({
        version: 3,
        path: `queues/${id}`,
        method: 'PATCH',
        body: queue,
      }),
    }),
    readQueues: builder.query<ReadQueuesApiResponse, ReadQueuesApiArg>({
      query: (arg) =>
        paginatedQuery(arg, (arg) => ({
          version: 3,
          path: 'queues',
          params: {
            is_archived: arg.isArchived,
            agent_id: arg.agentId,
            queue_id: arg.queueIds,
          },
        })),
    }),
    createQueueAgents: builder.mutation<ApiResponse, CreateQueueAgentsApiArg>({
      query: ({ id, agentIds }) => ({
        version: 2,
        path: `queues/${id}/agents`,
        method: 'PUT',
        body: {
          agents: agentIds.map((agent_id) => ({
            agent_id,
          })),
        },
      }),
    }),
    readQueueAgents: builder.query<
      ReadQueueAgentsApiResponse,
      ReadQueueAgentsApiArg
    >({
      query: (arg) =>
        paginatedQuery(arg, ({ id }) => ({
          version: 2,
          path: `queues/${id}/agents`,
        })),
    }),
    updateQueueAgents: builder.mutation<ApiResponse, UpdateQueueAgentsApiArg>({
      query: ({ id, agents }) => ({
        version: 2,
        path: `queues/${id}/agents`,
        method: 'PUT',
        body: {
          agents,
        },
      }),
    }),
    deleteQueueAgents: builder.mutation<ApiResponse, DeleteQueueAgentsApiArg>({
      query: ({ id, agentIds: agents }) => ({
        version: 2,
        path: `queues/${id}/agents`,
        method: 'DELETE',
        body: { agents },
      }),
    }),
    createQueueTeams: builder.mutation<ApiResponse, CreateQueueTeamsApiArg>({
      query: ({ id, teamIds }) => ({
        version: 2,
        path: `queues/${id}/teams`,
        method: 'PUT',
        body: {
          agents: teamIds.map((team_id) => ({
            team_id,
          })),
        },
      }),
    }),
    readQueueTeams: builder.query<
      ReadQueueTeamsApiResponse,
      ReadQueueTeamsApiArg
    >({
      query: (arg) =>
        paginatedQuery(arg, ({ id }) => ({
          version: 2,
          path: `queues/${id}/teams`,
        })),
    }),
    updateQueueTeams: builder.mutation<ApiResponse, UpdateQueueTeamsApiArg>({
      query: ({ id, teams }) => ({
        version: 2,
        path: `queues/${id}/teams`,
        method: 'PUT',
        body: {
          teams,
        },
      }),
    }),
    deleteQueueTeam: builder.mutation<ApiResponse, DeleteQueueTeamApiArg>({
      query: ({ id, teamId }) => ({
        version: 2,
        path: `queues/${id}/teams/${teamId}`,
        method: 'DELETE',
      }),
    }),
  }),
});
